import { adminFetch } from "./_client";
import type { DisputeRow, DisputeDetail, DisputeEvidence, DisputeDecision } from "./types";


export function listDisputes(token: string, params: { status?: string; source?: string; q?: string; limit?: number; offset?: number } = {}) {
  const sp = new URLSearchParams();
  if (params.status) sp.set("status", params.status);
  if (params.source) sp.set("source", params.source);
  if (params.q) sp.set("q", params.q);
  if (params.limit) sp.set("limit", String(params.limit));
  if (params.offset) sp.set("offset", String(params.offset));
  const qs = sp.toString();
  return adminFetch<{ rows: DisputeRow[]; total: number; limit: number; offset: number }>(`/admin/disputes${qs ? `?${qs}` : ""}`, token);
}

export function getDispute(token: string, id: number) {
  return adminFetch<{ dispute: DisputeDetail; evidence: DisputeEvidence[]; decisions: DisputeDecision[] }>(`/admin/disputes/${id}`, token);
}

export function createDispute(token: string, body: Partial<DisputeDetail> & { note?: string }) {
  return adminFetch<{ dispute: DisputeDetail }>(`/admin/disputes`, token, { method: "POST", body: JSON.stringify(body) });
}

export function patchDispute(token: string, id: number, body: Partial<DisputeDetail> & { note?: string }) {
  return adminFetch<{ dispute: DisputeDetail }>(`/admin/disputes/${id}`, token, { method: "PATCH", body: JSON.stringify(body) });
}

export function decideDispute(token: string, id: number, body: { decision: string; reason_code?: string; notes?: string }) {
  return adminFetch<{ dispute: DisputeDetail }>(`/admin/disputes/${id}/decide`, token, { method: "POST", body: JSON.stringify(body) });
}

export function addDisputeEvidence(token: string, id: number, body: { kind?: string; filename?: string; mime_type?: string; storage_key?: string; note?: string }) {
  return adminFetch<{ evidence: DisputeEvidence }>(`/admin/disputes/${id}/evidence`, token, { method: "POST", body: JSON.stringify(body) });
}
